<template>
  <div class="informatives-page mt-4">
    <app-page-header title="Notícias anteriores"></app-page-header>

    <div class="container-md">
      <div class="row">
        <div
          v-for="informative in data"
          :key="`informative-${informative.id}`"
          class="col-xl-4 col-sm-6"
        >
          <informative-card
            @click="viewInformative(informative)"
            class="informatives-card"
            :informative="informative"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <b-pagination
            @change="onPageChange"
            :total="total"
            :current.sync="page"
            :per-page="perPage"
            :range-before="1"
            :range-after="1"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InformativeService from '@/services/informative.service';
import InformativeCard from '@/components/Informative/InformativeCard.vue';

export default {
  name: 'informatives-page',
  components: {
    InformativeCard,
  },
  data: () => {
    return {
      isLoading: true,
      data: [],
      page: 1,
      perPage: 5,
      total: 0,
    };
  },
  methods: {
    load() {
      InformativeService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { data, total } = response.data;

          this.total = total;
          this.data = data;
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    viewInformative(informative) {
      this.$router.push({
        name: 'club.informatives.view',
        params: {
          id: informative.id,
        },
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.informatives-page {
  position: relative;
}

.informatives-card {
  margin: 1em auto;
  transition: 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}
</style>
